import { Routes } from '@angular/router';
import { oAuthCanMatch } from '@qaroni-core/guards/authentication/authentication.guard';
import { LayoutComponent } from './components/layout/layout.component';
import { PanelLayoutComponent } from './components/panel-layout/panel-layout.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('../auth/auth.routes'),
      },
    ],
  },
  {
    path: '',
    component: PanelLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'operations',
        pathMatch: 'full',
      },
      {
        path: 'operations',
        canMatch: [oAuthCanMatch],
        loadComponent: () =>
          import(
            './../operations/components/operations/operations.component'
          ).then(c => c.OperationsComponent),
      },
      {
        path: 'histories',
        canMatch: [oAuthCanMatch],
        loadComponent: () =>
          import(
            './../histories/components/histories/histories.component'
          ).then(c => c.HistoriesComponent),
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
];
